import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function CarrierNetwork({ fill, stroke, ...props }: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M7 7H4.5C4.19 7 3.89 7.15 3.7 7.4L1.4 10.47C1.14 10.82 1 11.24 1 11.67V15C1 15.55 1.45 16 2 16V14.67C2 13.0084 2.1386 12.8218 2.39609 12.4753L2.4 12.47L3.5013 11H2.54L4.5 8.5H7V9H8V8C8 6.5 9 5 11 5H21C21 3.9 20.1 3 19 3H9C7.9 3 7 3.9 7 5V7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 10H9V8C9 6.9 9.9 6 11 6H21C22.1 6 23 6.9 23 8V17C23 18.1 22.1 19 21 19C21 20.66 19.66 22 18 22C16.34 22 15 20.66 15 19H11C11 20.66 9.66 22 8 22C6.34 22 5 20.66 5 19H4C3.45 19 3 18.55 3 18V14.67C3 14.24 3.14 13.82 3.4 13.47L5.7 10.4C5.89 10.15 6.19 10 6.5 10ZM18 20C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18C17.45 18 17 18.45 17 19C17 19.55 17.45 20 18 20ZM9 19C9 19.55 8.55 20 8 20C7.45 20 7 19.55 7 19C7 18.45 7.45 18 8 18C8.55 18 9 18.45 9 19ZM6.5 11.5L4.54 14H9V11.5H6.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export { CarrierNetwork };
